import React__default from 'react';
import Slot from '../layout/slot/slot.esm.js';
import Heading from '../text/heading.esm.js';
import Text from '../text/text.esm.js';
import Anchor from '../anchor/anchor.esm.js';

var TooltipContentDefault = function TooltipContentDefault(props) {
  var heading = props.heading,
    text = props.text,
    link = props.link;
  return /*#__PURE__*/React__default.createElement(Slot, {
    direction: "vertical",
    gap: "lg"
  }, heading ? /*#__PURE__*/React__default.createElement(Heading, {
    as: "h3",
    variant: "heading-16"
  }, heading) : null, text ? /*#__PURE__*/React__default.createElement(Text, null, text) : null, link ? /*#__PURE__*/React__default.createElement(Anchor, {
    href: link.href,
    rel: "noreferrer noopener",
    target: "_blank"
  }, link.label) : null);
};
var TooltipContentDefault$1 = TooltipContentDefault;

export { TooltipContentDefault$1 as default };
//# sourceMappingURL=tooltip-content-default.esm.js.map
